module.exports = __webpack_public_path__ + "static/img/mo1.4af2f91.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/control2/mo1.png
// module id = biZo
// module chunks = 7